import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0px 20px 20px 20px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
